
/* injects from baggage-loader */

'use strict';

import moment from 'moment';

export default class ProjectListItemController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {
		
	}

	/**
	 * Returns the number of days remianing until the end of the raise
	 * @param {Object} project 
	 */
	daysRemaining(project) {
		let days = moment(project.get('end_date')).diff(moment(), 'days');
		return days > 0 ? days : 0;
	}

}



// WEBPACK FOOTER //
// ./src/app/components/projectListItem/projectlistitem.controller.js